import { isB2B } from "utils/contractEntity";
import { Tag } from "./Tag";

type Props = {
  contractType?: string | null;
  contractEntity?: string | null;
};

export const ContractBadges = ({ contractType, contractEntity }: Props) => {
  if (!isB2B(contractType)) return null;

  return (
    <span className="inline-flex items-center gap-1 ml-2 align-middle whitespace-nowrap">
      <Tag
        variant="primary"
        className="!text-[11px] !px-1.5 !py-0 !shadow-none"
      >
        B2B
      </Tag>
      {contractEntity && (
        <Tag
          variant="default"
          className="!text-[11px] !px-1.5 !py-0 !shadow-none"
        >
          {contractEntity}
        </Tag>
      )}
    </span>
  );
};
